var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 12.727a.8.8 0 01-1.147.72L8.347 11.76a.8.8 0 00-.694 0l-3.506 1.688A.8.8 0 013 12.728V2.8a.8.8 0 01.8-.8h8.4a.8.8 0 01.8.8v9.927z",
    stroke: "#7D8085",
    strokeWidth: 1.2
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzIDEyLjcyN0MxMyAxMy4zMTY1IDEyLjM4NDIgMTMuNzAzNiAxMS44NTMgMTMuNDQ3OUw4LjM0Njk4IDExLjc2MDJDOC4xMjc3IDExLjY1NDcgNy44NzIzIDExLjY1NDcgNy42NTMwMiAxMS43NjAyTDQuMTQ2OTkgMTMuNDQ3OUMzLjYxNTg1IDEzLjcwMzYgMyAxMy4zMTY1IDMgMTIuNzI3MUwzIDIuOEMzIDIuMzU4MTcgMy4zNTgxNyAyIDMuOCAyTDEyLjIgMkMxMi42NDE4IDIgMTMgMi4zNTgxNyAxMyAyLjhMMTMgMTIuNzI3WiIgc3Ryb2tlPSIjN0Q4MDg1IiBzdHJva2Utd2lkdGg9IjEuMiIvPgo8L3N2Zz4=";
export { SvgTag as ReactComponent };